var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpectrumLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 26,
    viewBox: "0 0 177 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21002 2.24268C0.74756 3.73753 0 5.49255 0 7.57276C0 9.68483 0.74756 11.4725 2.21002 12.9676C3.67222 14.4301 5.45989 15.1771 7.57222 15.1771H14.0398C14.9498 15.1771 15.6971 15.5026 16.3473 16.1522C16.9647 16.8023 17.3223 17.5499 17.3223 18.4275C17.3223 18.8823 17.2244 19.3051 17.0622 19.6951C16.8997 20.1172 16.6722 20.4419 16.3797 20.735C16.0874 21.0275 15.7298 21.2547 15.3072 21.4172C14.9172 21.5797 14.4948 21.645 14.0398 21.645V26C16.1524 26 17.9398 25.2522 19.402 23.7897C20.8969 22.2946 21.6447 20.5075 21.6447 18.4275C21.6447 16.3473 20.8969 14.5602 19.402 13.065C17.9398 11.6026 16.1524 10.855 14.0398 10.855H7.57222C6.63007 10.855 5.88225 10.5295 5.23238 9.87994C4.6149 9.23008 4.32235 8.48252 4.32235 7.57276C4.32235 7.14987 4.38739 6.72777 4.54986 6.3378C4.71259 5.94783 4.93983 5.59024 5.23238 5.29743C5.55731 4.9725 5.88224 4.74525 6.30487 4.58252C6.69511 4.42005 7.1172 4.35528 7.57222 4.35528V0C5.45989 0 3.67222 0.747292 2.21002 2.24268Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6447 0H0V26H21.6447V0Z",
    fill: "url(#paint0_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 22,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0096 0.000488281L28.3317 4.35577H37.0091C38.1793 4.35577 39.1867 4.77786 40.0317 5.62312C40.9094 6.46837 41.332 7.50794 41.332 8.67813C41.332 9.88044 40.877 10.8882 40.0317 11.7331C39.1867 12.5779 38.1793 13.0002 37.0091 13.0002H28.3317H24.0096V26.0005H28.3317V17.3555H37.0091C39.3818 17.3555 41.4291 16.5108 43.1194 14.8203C44.8417 13.1303 45.6541 11.0504 45.6541 8.67813C45.6541 6.30537 44.8093 4.25808 43.1194 2.53545C41.4291 0.845745 39.3818 0.000488281 37.0091 0.000488281H24.0096Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6541 0.000488281H24.0096V26.0005H45.6541V0.000488281Z",
    fill: "url(#paint1_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 18,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7498 21.6455L48.4275 25.6432V26.0005H65.7498V21.6455H52.7498ZM52.7498 10.8555H48.4275V15.1776H52.7498H65.7498V10.8555H52.7498ZM48.4275 0.000488281L52.7498 4.35577H65.7498V0.000488281H48.4275Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7498 0.000488281H48.4275V26.0005H65.7498V0.000488281Z",
    fill: "url(#paint2_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 0,
    width: 24,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9671 1.0406C74.3746 1.72285 73.0095 2.63314 71.807 3.83545C70.6368 5.00564 69.6946 6.37014 69.0121 7.93057C68.3293 9.52312 67.9723 11.2131 67.9723 13.0002C67.9723 14.7552 68.3293 16.4125 69.0121 18.0051C69.6946 19.5976 70.6368 20.9627 71.807 22.165C73.0095 23.3355 74.3746 24.2776 75.9671 24.9601C77.527 25.6432 79.217 26.0005 81.0047 26.0005C82.7921 26.0005 84.4818 25.6756 86.0419 24.9928L81.0047 21.6455C79.8021 21.6455 78.6969 21.4177 77.6247 20.9953C76.5846 20.5406 75.6743 19.9228 74.8946 19.1102C74.082 18.3306 73.4646 17.4203 73.0096 16.3807C72.5543 15.3077 72.327 14.2028 72.327 13.0002C72.327 11.7979 72.5543 10.693 73.0096 9.62054C73.4646 8.58043 74.082 7.67068 74.862 6.89046C75.6422 6.07813 76.5522 5.46065 77.6247 5.00563C78.6646 4.58301 79.8021 4.35577 81.0047 4.35577C83.3445 4.35577 85.3918 5.16783 87.1144 6.85781L90.2018 3.83545C88.9995 2.63314 87.6018 1.69073 86.0419 1.00794C84.4818 0.325691 82.7921 0.000488281 81.0047 0.000488281C79.217 0.000488281 77.527 0.358343 75.9671 1.0406Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2018 0.000488281H67.9723V26.0005H90.2018V0.000488281Z",
    fill: "url(#paint3_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 0,
    width: 14,
    height: 27
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6151 0.000488281V4.35577V26.0005H97.9701V4.35577H106.615V0.000488281H93.6151Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.615 0.000488281H93.6151V26.0005H106.615V0.000488281Z",
    fill: "url(#paint4_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 0,
    width: 21,
    height: 27
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.788 0.000488281L112.03 3.8681L112.518 4.35577H121.195C122.365 4.35577 123.372 4.77786 124.217 5.62312C125.095 6.46837 125.517 7.47555 125.517 8.64547C125.517 9.84805 125.095 10.8882 124.217 11.7331C123.372 12.5779 122.365 13.0002 121.195 13.0002L117.327 12.9681L124.868 26.0005H129.84L124.51 16.6727C126.037 16.0555 127.305 15.0154 128.313 13.5532C129.353 12.0907 129.84 10.4655 129.84 8.64547C129.84 6.27298 128.995 4.25808 127.305 2.53545C125.615 0.845745 123.567 0.000488281 121.195 0.000488281H109.788Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.84 0.000488281H109.788V26.0005H129.84V0.000488281Z",
    fill: "url(#paint5_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 0,
    width: 23,
    height: 27
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.833 0.000488281V15.1776C132.833 18.1352 133.872 20.7355 135.985 22.8481C138.098 24.9601 140.665 26.0005 143.623 26.0005C146.58 26.0005 149.18 24.9601 151.292 22.8481C153.437 20.7355 154.477 18.1678 154.477 15.1776H150.154C150.154 16.9329 149.472 18.4604 148.205 19.7277C146.938 20.9953 145.41 21.6455 143.623 21.6455C141.835 21.6455 140.275 21.028 139.008 19.7277C137.773 18.4928 137.155 16.9655 137.155 15.1776V0.000488281H132.833Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.477 0.000488281H132.832V26.0005H154.477V0.000488281Z",
    fill: "url(#paint6_linear_591_9789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_591_9789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 0,
    width: 27,
    height: 27
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.24 13.0002L150.208 0.000488281V6.04548L163.24 19.1429L171.95 10.4655V26.0005H176.24V0.000488281L163.24 13.0002Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_591_9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.24 0.000488281H150.208V26.0005H176.24V0.000488281Z",
    fill: "url(#paint7_linear_591_9789)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_591_9789",
    x1: 0.00749066,
    y1: 13.0076,
    x2: 21.6524,
    y2: 13.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A71C20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_591_9789",
    x1: 24.0233,
    y1: 13.0081,
    x2: 45.6685,
    y2: 13.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1268B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_591_9789",
    x1: 48.4256,
    y1: 12.9672,
    x2: 65.7479,
    y2: 12.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4130"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_591_9789",
    x1: 67.9645,
    y1: 13.0059,
    x2: 90.1943,
    y2: 13.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_591_9789",
    x1: 93.6111,
    y1: 12.9969,
    x2: 106.611,
    y2: 12.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B72126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_591_9789",
    x1: 109.776,
    y1: 13.0121,
    x2: 129.828,
    y2: 13.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1268B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_591_9789",
    x1: 132.837,
    y1: 13.0081,
    x2: 154.482,
    y2: 13.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4130"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_591_9789",
    x1: 150.214,
    y1: 12.9746,
    x2: 176.246,
    y2: 12.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00944A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrumLogo);
export default __webpack_public_path__ + "static/media/spectrumLogo.34a5924e0b824027193d03db3af22407.svg";
export { ForwardRef as ReactComponent };